import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { QUESTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { QuestionMonitorPage } from '@/features/question/pages/QuestionMonitorPage';
import { monitorPageSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/download')({
  beforeLoad: () => requirePermission(QUESTION_PERMISSIONS.DOWNLOAD_VIEW),
  validateSearch: monitorPageSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Question Download">
      <Suspense fallback={<PageLoader />}>
        <QuestionMonitorPage routeId="download" screen="member" title="Question Download" />
      </Suspense>
    </ErrorBoundary>
  ),
});
